import { render, staticRenderFns } from "./ChatbotInput.vue?vue&type=template&id=7cbf5898&scoped=true&"
import script from "./ChatbotInput.vue?vue&type=script&lang=js&"
export * from "./ChatbotInput.vue?vue&type=script&lang=js&"
import style0 from "./ChatbotInput.vue?vue&type=style&index=0&id=7cbf5898&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cbf5898",
  null
  
)

export default component.exports